import React from "react";
import Card, { CardBody, CardTitle } from "./Card";

/**
 * Carte avec titre destinée à accueillir un graphique.
 * `fill` : le contenu est placé dans un CardBody qui prend toute la hauteur.
 */
const ChartCard = ({
    title,
    children,
    fill = false,
    end = false,
    ...props
}) => {
    return (
        <Card column={fill} indicatorLabel={title} {...props}>
            <CardTitle>{title}</CardTitle>
            {fill ? <CardBody $end={end}>{children}</CardBody> : children}
        </Card>
    );
};

export default ChartCard;
